import mitt from 'mitt';

const eventbus = mitt();
export default eventbus;
